import { EventEmitter, Injectable, Output } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { IMessage } from 'app/pages/messages/message-interface';
import { PayorInterface } from '../interfaces/payor.interface';
import { IUserType } from '../interfaces/user-type.interface';
import { ICompany } from '../interfaces/company.interface';

@Injectable()
export class MessageService extends ParentService {

  private getDataEdit = new BehaviorSubject<IMessage>(null);
  getDataEdit$ = this.getDataEdit.asObservable();

  @Output() showModalMessage = new EventEmitter<{ isOpen: boolean }>(null);
  @Output() reloadGrid = new EventEmitter<boolean>(null);

  constructor(private http: Http) {
    super();
  }

  readMessage(data: any): Observable<any> {
    const url = `${constant.URL_PUT_MESSAGES}/${data}`;
    return this.http
      .post(url, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch((error: any) => Observable.throw(error.json()));
  }

  sendDataForm(data: IMessage) {
    this.getDataEdit.next(data);
  }

  getMessagesAll(): Observable<IMessage[]> {
    return this.http
      .get(constant.URL_MESSAGE, this.getHeader())
      .pipe(map((response: any) => response.json() as IMessage[]))
      .catch(error => Observable.throw(error.json()));
  }

  getUserType(): Observable<IUserType[]> {
    return this.http
      .get(constant.USER_TYPE, this.getHeader())
      .pipe(map((response: any) => response.json() as IUserType[]))
      .catch(error => Observable.throw(error.json()));
  }

  getPayorList(): Observable<PayorInterface[]> {
    return this.http
      .get(constant.URL_PAYOR_LIST, this.getHeader())
      .pipe(map((response: any) => response.json() as PayorInterface[]))
      .catch(error => Observable.throw(error.json()));
  }

  getProviderList(): Observable<ICompany[]> {
    return this.http
      .get(constant.USER_PROVIDERS, this.getHeader())
      .pipe(map((response: any) => response.json() as ICompany[]))
      .catch(error => Observable.throw(error.json()));
  }

  putMessage(data: IMessage): Observable<IMessage> {
    return this.http
      .put(constant.URL_MESSAGE, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch(error => Observable.throw(error.json()));
  }

  postMessage(data: IMessage): Observable<IMessage> {
    return this.http
      .post(constant.URL_MESSAGE, data, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch(error => Observable.throw(error.json()));
  }

  deleteMessage(id: number): Observable<number> {
    const url = `${constant.URL_MESSAGE}/delete/${id}`;
    return this.http
      .put(url, id, this.headerPost())
      .pipe(map((response: any) => response.json()))
      .catch(error => Observable.throw(error.json()));
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/message.service.ts